(function () {
    angular.module('tmx-app').directive("tmxHtmlArea", tmxHtmlArea);

    function tmxHtmlArea() {
        return {
            scope: {
                name: "@",
                path: "="                
            },
            restrict: 'E',
            templateUrl: 'common/directives/tmxHtmlArea/tmxHtmlArea.html',
            controller: tmxHtmlAreaCtrl,
            controllerAs: 'tmxHtmlAreaCtrl'
        };

    }

    function tmxHtmlAreaCtrl($scope,tmxResource) {
        var tmxHtmlAreaVM=this;
        tmxHtmlAreaVM.scope=$scope;
        $scope.htmlContent = "";
        if(tmxHtmlAreaVM.scope.path && tmxHtmlAreaVM.scope.path.includes('server')) {
            var htmlPath = tmxHtmlAreaVM.scope.path.replace('server//','');
            $scope.server = true;
            tmxResource('Public').getByAction('GetServerResource',false,'post',{"FileName" : htmlPath}).then(function(response) {
                if(!angular.isDefined(response.data)) {
                    $scope.htmlContent = response;
                }                
            });
        } 
        else if(tmxHtmlAreaVM.scope.path && tmxHtmlAreaVM.scope.path.includes('local')){
            $scope.local = true;
            $scope.htmlPath = tmxHtmlAreaVM.scope.path.replace('local//','');            
        }              
    }

})();